import React, { useState } from 'react';
import { KeySquare } from 'lucide-react';

const ChangePasswordForm = ({ initialFormData, onSubmit, onCancel }) => {
    const [formData, setFormData] = useState(initialFormData);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <div className=" rounded-lg shadow-sm">
            <div className="space-y-6  p-6 rounded-lg">
                <form onSubmit={handleSubmit}>
                    <div className="space-y-6">
                        <div>
                            <label htmlFor="oldPassword" className="block text-sm font-medium text-gray-200 mb-1">
                                Old Password
                            </label>
                            <div className="flex">
                                <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500">
                                    <KeySquare className="h-4 w-4" />
                                </span>
                                <input
                                    type="password"
                                    name="oldPassword"
                                    id="oldPassword"
                                    value={formData.oldPassword}
                                    onChange={handleChange}
                                    required
                                    className="flex-1 min-w-0 px-4 py-2 border border-gray-300 rounded-r-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="newPassword" className="block text-sm font-medium text-gray-200 mb-1">
                                New Password
                            </label>
                            <div className="flex">
                                <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500">
                                    <KeySquare className="h-4 w-4" />
                                </span>
                                <input
                                    type="password"
                                    name="newPassword"
                                    id="newPassword"
                                    value={formData.newPassword}
                                    onChange={handleChange}
                                    required
                                    className="w-full px-4 py-2 border border-gray-300 rounded-r-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-end space-x-4 mt-6">
                        <button
                            type="submit"
                            className="px-6 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white brand-blue hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                            Change Password
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChangePasswordForm;
